<template lang="pug">
  .popup-uploader
    .popup-uploadImage.popup-uploadArticleImage
      .popup-imageUploadImage(
        :style='defaultImage' 
        alt='image-placehoder'
        ref="imagePreview"
        )

      // show this before image's uploaded  and remove when image's uploaded

      span.popup-textUploadImage(v-if='!this.isImageUploaded')
        | 檔案可支援類型 .jpg, .png, .pdf，檔案大小請於100MB以內，圖片以 960x720 或 640x480 (4:3) 為佳。
        
      div.popup-textUploadImage(v-else)
        span.popup-fileName.ellipsis-single {{fileName}}
        button.popup-buttonClear(@click="clearUpload" ) 刪除檔案
        
      // loading
      loading(loader='dots', :active.sync='isLoading', :is-full-page='false')

      .popup-uploadImageRight
        ButtonUploadImage(
          @setUploading='setUploading'
          @setThumbnailPreview='setThumbnailPreview'
          @setImageUrl='setImageUrl'
          @setImageUploaded='setImageUploaded'
          @setImageFileName='setImageFileName'
          @setImageFile='setImageFile'
        )
    .popup-thumbTextareaWrapper(
      v-if="isImageUploaded || defaultThumbCaption || govAnnounceImageUrl"
      )
      textarea(
        :class='alert.thumbTitle.textarea'
        rows='4'
        placeholder='請輸入圖片標題'
        v-model='params.thumbTitle'
        maxlength='100'
        @input='checkActive(); updateThumbTitle()'
        )
      .popup-alertText(v-if='alert.thumbTitle.alertText') 已達字數上限
      div(:class='alert.thumbTitle.counter')
        span.popup-remainingCounter {{ params.thumbTitle.length }}
        span.popup-limitCounter {{ contentLimit }}
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { getCategoryImgURL } from '@/plugins/tool.js';
import { checkPopupAlert } from '@/plugins/tool.js';
import ButtonUploadImage from '@/components/modules/button/button_upload_image.vue';

export default {
  name: 'ImageUploadArticleImage',
  components: {
    Loading,
    ButtonUploadImage
  },
  props: {
    govAnnounceImageUrl: {
      type: String,
      default: () => ''
    },
    defaultThumbCaption: {
      tpe: String,
      default: () => ''
    }
  },
  data() {
    return {
      isActive: false,
      isLoading: false,
      contentLimit: 100,
      alert: {
        thumbTitle: {
          textarea: 'popup-textarea',
          alertText: false,
          counter: 'popup-counter'
        }
      },
      params: {
        thumbTitle: this.defaultThumbCaption,
        imageUrl: ''
      },
      isImageUploaded: false,
      fileName: ''
    };
  },
  computed: {
    defaultImage() {
      if (!this.govAnnounceImageUrl)
        return (
          "background-image: url('" +
          getCategoryImgURL('/fig-default-2.png') +
          "');"
        );
      else return "background-image: url('" + this.govAnnounceImageUrl + "');";
    }
  },
  methods: {
    setUploading(isUploading) {
      if (isUploading === true) this.isLoading = true;
      else this.isLoading = false;
    },
    checkActive() {
      this.alert.content = checkPopupAlert(
        this.params.thumbTitle.length > this.contentLimit,
        this.alert.content
      );
      if (this.params.thumbTitle.length <= this.contentLimit) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
    setThumbnailPreview(val) {
      this.$refs.imagePreview.style = "background-image: url('" + val + "');";
    },
    setImageUrl(val) {
      this.params.imageUrl = val;
    },
    setImageFile(val) {
      this.$emit('uploadImg', val);
    },
    resetThumbnail() {
      this.$refs.imagePreview.style =
        "background-image: url('" +
        getCategoryImgURL('/fig-default-2.png') +
        "');";
    },
    clearUpload() {
      this.resetThumbnail();
      this.fileName = '';
      this.params.thumbTitle = '';
      this.params.imageUrl = '';

      this.isImageUploaded = false;
      this.$emit('uploadImg', null);
      this.$emit('setThumbTitle', this.params.thumbTitle);
    },
    updateThumbTitle() {
      this.$emit('setThumbTitle', this.params.thumbTitle);
    },
    setImageUploaded(val) {
      this.isImageUploaded = val;
    },
    setImageFileName(val) {
      this.fileName = val;
    }
  }
};
</script>

<style scoped src="./image_upload_article_image.vue.css"></style>
